		var youtobeSwipers = new Swiper(".youtobeSwipers .mySwiper", {
			slidesPerView:4,
			spaceBetween: 20,
		    navigation: {
		        nextEl: ".youtobeSwipers .swiper-button-next",
		        prevEl: ".youtobeSwipers .swiper-button-prev",
		    },
			autoplay:{
                                speed:800,
                                delay:3000,
                        },
			breakpoints: {
				320: {
				  slidesPerView: 1,
				  spaceBetween: 10,
				},
				768: {
				  slidesPerView: 2,
				  spaceBetween: 10,
				},
				1024: {
				  slidesPerView: 4,
				  spaceBetween: 20,
				},
			},
		});
		var youtobeAlt = new Swiper(".altDetail .mySwiper", {
		    navigation: {
		        nextEl: ".youtobeNext",
		        prevEl: ".youtobePrev",
		    },
			on: {
			    slideChangeTransitionStart: function(){
					var nums = this.activeIndex;
					var iframeSrc = $('.youtobeSwipers .swiper-slide').eq(nums).attr('data-src');
					$('.altDetail iframe').attr('src','');
					$('.altDetail .swiper-slide').eq(nums).find('iframe').attr('src',iframeSrc)
			    },
			},
		});
		$('.youtobeClose').click(function(){
			$('#ytbShadow,.youtobeAlt').fadeOut();
			$('.altDetail iframe').attr('src','');
		})
		$('.youtobeSwipers').on('click','.swiper-slide',function(){
			var num = $(this).index();
			youtobeAlt.slideTo(num);
			var videoSrc = $(this).attr('data-src');
			$('.altDetail .swiper-slide').eq(num).find('iframe').attr('src',videoSrc)
			$('#ytbShadow,.youtobeAlt').fadeIn();
		})
		$('.reputon-description').click(function(){
			if($(this).hasClass('controlHeight')){
				$(this).removeClass('controlHeight')
				$(this).siblings('.controlShort').html('...less')
			}else{
				$(this).addClass('controlHeight')
				$(this).siblings('.controlShort').html('...more')
			}
		})
		$('.controlShort').click(function(){
			if($(this).siblings('.reputon-description').hasClass('controlHeight')){
				$(this).html('...less')
				$(this).siblings('.reputon-description').removeClass('controlHeight')
			}else{
				$(this).html('...more')
				$(this).siblings('.reputon-description').addClass('controlHeight')
			}
		})